<template>
  <Form :method="method"
        :action="action"
        :form-data="form"
        @success="success">
    <template v-slot="{ errors, submitting }">
      <label class="block mb-3">
        <span class="block mb-1">
          Nieuwe tag
        </span>
        <BaseInput v-model="form.name"
                   :error="errors.name"
                   name="name"
                   class="w-full"
                   maxlength="20"
                   required
                   v-focus />
        <div class="text-sm text-gray-400 mt-1">Maximaal 20 tekens, geen spaties</div>
      </label>
      <div class="flex pt-2">
        <button type="submit"
                class="btn btn-blue"
                :disabled="submitting">Opslaan</button>
        <button type="button"
                class="cancel"
                @click="close">Annuleren</button>
      </div>
    </template>
  </Form>
</template>

<script>
import Form from "@/components/Form";

export default {
  inject: ["close"],

  props: {
    method: {
      type: String,
      default: "post"
    },
    action: {
      type: String,
      required: true
    }
  },

  components: {
    Form
  },

  data() {
    return {
      form: {
        name: ""
      }
    };
  },

  watch: {
    form: {
      handler() {
        this.form.name = this.form.name.replace(" ", "-");
      },
      deep: true
    }
  },

  methods: {
    success(data) {
      this.$emit("success", data);
      this.$store.commit("FLASH_ADD", {
        message: `Tag ${this.form.name} is opgeslagen!`
      });
      this.close();
    }
  }
};
</script>
